export default "__VITE_ASSET__CGhBlYvQ__"